
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1B4F72] text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="md:col-span-1">
            <Link to="/">
              <img 
                src="/img/logo_footer.png"
                alt="YOGA 7 Logo" 
                className="w-24 h-24 object-contain cursor-pointer mb-4"
              />
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-white hover:text-[#00BCD4] transition-colors">Home</Link></li>
              <li><Link to="/classes" className="text-white hover:text-[#00BCD4] transition-colors">Classes</Link></li>
              <li><Link to="/schedule" className="text-white hover:text-[#00BCD4] transition-colors">Schedule</Link></li>
              {/*<li><Link to="/membership" className="text-white hover:text-[#00BCD4] transition-colors">Membership</Link></li>*/}
              <li><Link to="/buy-now?_mt=%2Fbuy%2F48717" className="text-white hover:text-[#00BCD4] transition-colors">Membership</Link></li>
              <li><Link to="/events-children" className="text-white hover:text-[#00BCD4] transition-colors">Events</Link></li>
              <li><Link to="/contact" className="text-white hover:text-[#00BCD4] transition-colors">Contact</Link></li>
              <li><Link to="/terms" className="text-white hover:text-[#00BCD4] transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy" className="text-white hover:text-[#00BCD4] transition-colors">Privcy Policy</Link></li>
              <li><Link to="/waiver" className="text-white hover:text-[#00BCD4] transition-colors">Waiver</Link></li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">About</h3>
            <ul className="space-y-2">
              <li><Link to="/studio" className="text-white hover:text-[#00BCD4] transition-colors">Studio</Link></li>
              <li><Link to="/far-infrared-heat" className="text-white hover:text-[#00BCD4] transition-colors">Far Infrared Heat</Link></li>
              <li><Link to="/our-values-&-ethics" className="text-white hover:text-[#00BCD4] transition-colors">Our Values & Ethics</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-[#00BCD4] mt-1 mr-3"></i>
                <p className="text-white text-sm">
                  105-19925 Willowbrook Dr., Langley<br />
                  Located near Willowbrook Shopping Centre
                </p>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-[#00BCD4] mr-3"></i>
                <p className="text-white text-sm">(778) 237-7790</p>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-[#00BCD4] mr-3"></i>
                <p className="text-white text-sm">info@yogaseven.com</p>
              </div>
            </div>
            
            {/* Social Media */}
            <div className="mt-6">
              <h4 className="text-sm font-semibold mb-3 text-white">Follow Us</h4>
              <div className="flex space-x-3">
                <a href="https://www.instagram.com/yogasevenstudio?igsh=MWtsY3lhd2piZW5hcg%3D%3D&utm_source=qr" className="w-8 h-8 bg-[#14B6A4] rounded-full flex items-center justify-center hover:bg-[#12a08f] transition-colors">
                  <i className="ri-instagram-line text-white text-sm"></i>
                </a>
                <a href="https://www.facebook.com/profile.php?id=61585312964707" className="w-8 h-8 bg-[#14B6A4] rounded-full flex items-center justify-center hover:bg-[#12a08f] transition-colors">
                  <i className="ri-facebook-fill text-white text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#2E5984] mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white text-sm">
            © 2025 YOGA 7. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
